/**
 * HUB-F — KPI réparations + visibilité M1 / M2.
 */
import React from 'react';
import { magasinScopeLabel } from '../../utils/reparations/reparationsDisplay';
import MagasinBadge from '../MagasinBadge';

export default function ActiviteReparationsKpiStrip({ kpis, magasinId, magasinCounts }) {
  const scope = magasinScopeLabel(magasinId);

  return (
    <div className="space-y-3" data-testid="activite-reparations-kpi">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-[var(--rm-gray-500)]">Périmètre :</span>
        {magasinId ? (
          <MagasinBadge code={magasinId} size="sm" />
        ) : (
          <span className="rm-badge rm-badge--muted" data-testid="activite-reparations-scope-all">{scope}</span>
        )}
      </div>

      {!magasinId && magasinCounts && (
        <div className="grid grid-cols-2 gap-2 text-xs" data-testid="activite-reparations-kpi-magasin-breakdown">
          {['M1', 'M2'].map((code) => (
            <div
              key={code}
              className="rounded-lg border px-3 py-2"
              style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
            >
              <MagasinBadge code={code} size="sm" />
              <span className="text-[var(--rm-gray-400)] ml-2">
                {magasinCounts[code]?.en_cours ?? 0} en cours · {magasinCounts[code]?.attente_piece ?? 0} att. pièce · {magasinCounts[code]?.termine ?? 0} terminées
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 text-sm">
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-reparations-total">
          <div className="text-xs text-[var(--rm-gray-500)]">Période</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.total ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-reparations-en-cours">
          <div className="text-xs text-[var(--rm-gray-500)]">En cours (DATA-01)</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.en_cours ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-reparations-atelier">
          <div className="text-xs text-[var(--rm-gray-500)]">Atelier actif</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.en_cours_strict ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-reparations-attente-piece">
          <div className="text-xs text-[var(--rm-gray-500)]">Attente pièce</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.attente_piece ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-reparations-termine">
          <div className="text-xs text-[var(--rm-gray-500)]">Prêtes / terminées</div>
          <div className="font-bold text-[var(--rm-success)]">{kpis?.termine ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-reparations-livre">
          <div className="text-xs text-[var(--rm-gray-500)]">Livrées</div>
          <div className="font-bold text-[var(--rm-gray-400)]">{kpis?.livre ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
